import { Stacks } from "./stacks";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Keywords } from "./keywords";
import { BsMortarboardFill } from "react-icons/bs";
import { FaCheck } from "react-icons/fa6";
import Lottie from "lottie-react";
import animationData from "../../assets/lottie/laptop.json"

export const About = () => {
  return (
    <div className="bg-secondary">
      <AnimationOnScroll animateIn="animate__fadeIn duration-400">
        <div
          id="about"
          className="w-full sm:px-20 md:px-64 px-5 sm:py-20 py-12 flex flex-col sm:justify-start justify-center sm:items-start items-center gap-3 text-primary animate-fade-right animate-once animate-duration-400 animate-delay-2000 animate-ease-in-out animate-normal animate-fill-both"
        >
          <div className="text-[30px] font-[600]">Who I'm?</div>
          <div className="sm:text-[18px] text-[16px] text-center sm:text-left">
            Hello! I'm a passionate and innovative Front-end Developer driven by
            a user-centric approach. With a keen eye for detail and a knack for
            collaboration, I specialize in partnering with UI/UX designers to
            craft visually stunning and highly responsive websites.{" "}
            <span className="text-secondary">
              From tackling intricate challenges to crafting elegant front-end
              solutions, I thrive on creating seamless user experiences that
              leave a lasting impression.{" "}
            </span>{" "}
            Let's build something extraordinary together!
          </div>
          <div className="flex justify-center items-center w-full">
          <Lottie className="h-52" animationData={animationData} loop={true} />
          </div>

          <div className="text-[30px] font-[600] mt-3">My Stacks</div>
          <Stacks />
          <div className="text-[30px] font-[600] mt-3">Key Qualities</div>
          <u1 className="sm:text-[18px] text-[16px] list-none">
            {[
              "I deliver clean, maintainable code with a focus on long-term scalability and performance",
              "I approach problem-solving with a strategic mindset, optimizing for both efficiency and effectiveness",
              "I collaborate effectively with cross-functional teams, ensuring that design and development are perfectly aligned",
              "I'm proactive in identifying and resolving potential issues before they affect the user experience",
              "I excel at translating Figma designs into responsive, pixel-perfect user interfaces, ensuring a seamless experience across all devices",
            ].map((quality) => {
              return (
                <li className="flex justify-start items-start gap-x-3 w-full">
                  <FaCheck size={12} className="mt-1.5 w-[5%]" />
                  <div className="w-[95%]">{quality}</div>
                </li>
              );
            })}
          </u1>
          <div className="text-[30px] font-[600] mt-3">Education</div>
          <div className="flex justify-center flex-col gap-y-3 sm:flex-row sm:justify-between items-center w-full">
            <div className="flex flex-col sm:items-start items-center gap-1">
              <div className="flex justify-center items-center gap-x-3">
                <BsMortarboardFill size={20} className="sm:block hidden" />
                Ghulam Ishaq Khan Institute
              </div>
              <div className="sm:ml-8 text-[11px] font-light">
                Bachelor of Science (Engineering)
              </div>
              <div className="sm:ml-8 text-[11px] font-light">
                (2018 - 2022)
              </div>
            </div>
            <a target="_blank" rel="noreferrer" href="https://giki.edu.pk/">
              <img
                alt="giki"
                className="w-20"
                src="https://giki.edu.pk/wp-content/uploads/2019/11/Gik-logo-15-300x298.png"
              />
            </a>
          </div>
          <Keywords />
        </div>
      </AnimationOnScroll>
    </div>
  );
};
